import { RootState } from '~/store';

export const selectIsIntegrationUploading = (state: RootState) =>
  state.integrationBar.uploadInProgress;
